@if (sections.length > 0 && showOnlyGridFlag) {
<div class="question-container">
  <h3>Scope 1 & 2 questionnaire (CO₂e)</h3>
  <p>
    In the questionnaire both the “company” and “company site” terms are used as some suppliers are only delivering data
    for a single entity and some suppliers have more submissions to attend to for multiple sites within their company.
  </p>
  <p>
    To answer the questionnaire and submit your scope 1&2 CO₂e data, We recommend using the standard from the
    <a aria-label="GHG Protocol" target="_blank" href="https://ghgprotocol.org/">GHG Protocol</a>
    which sets standards to measure and manage emissions.
    <a aria-label="corporate standard details" target="_blank" href="https://ghgprotocol.org/corporate-standard">
      This link
    </a>
    provides access to the standard as well as tools and training material.
  </p>
  <p>Please answer all questions before submitting.</p>
  <article class="question-container__content">
    <ngx-masonry
      (layoutComplete)="reloadMasonryLayout()"
      [options]="{ fitWidth: true, gutter: 24 }"
      [ordered]="true"
      class="container-masonry"
    >
      @for (info of sections; track info; let i = $index) {
      <div [attr.data-index]="i" class="question-container__item" ngxMasonryItem>
        <app-editable-card
          (reloadCardData)="reloadCardData()"
          [actions]="info.actions"
          [data]="info"
          [tab]="data.name"
        ></app-editable-card>
      </div>
      }
    </ngx-masonry>
  </article>
</div>
}
